import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useSnackbar} from "../../../../../common/context/SnackbarContext";
import {useApiRequest} from "../../../../../common/hooks/useApiRequest";
import {WordWithId} from "../../../../../common/types/words";
import {useDeck} from "../../../../deck-management/context/DeckContext";

export interface UseUserTranslationsMutationArgs {
    wordId: string;
}

export const useUserTranslationsMutation = ({wordId}: UseUserTranslationsMutationArgs) => {

    const queryClient = useQueryClient();

    const {currentDeck} = useDeck();
    const {putRequest} = useApiRequest();
    const {showSnackbar} = useSnackbar();

    return useMutation({
        mutationFn: (userTranslations: string[]) =>
            putRequest<WordWithId>(`decks/${currentDeck?.deckId}/words/${wordId}/user-translations`, {
                translations: userTranslations,
            }),
        onSuccess: (_, userTranslations) => {
            queryClient.setQueryData(["word-info", wordId], (previousData: WordWithId | undefined) => {
                if (!previousData) {
                    return previousData;
                }

                return {
                    ...previousData,
                    userTranslations,
                };
            });
            showSnackbar("Translations saved", "success");
        },
        onError: () => {
            showSnackbar("Failed to save ", "error");
        },
    });
};
